import { useTranslation } from "react-i18next";
import { toArabicNumerals } from "../helpers";
import { formatDate } from "../helpers";

/**
 * Custom hook that provides a function to get localized text based on the current language
 * @returns {function} A function that takes Arabic and English text and returns the appropriate translation
 */
export function useLocalizedText() {
  const { i18n } = useTranslation();

  /**
   * Returns the appropriate text based on the current language
   * @param {string} ar - Arabic text
   * @param {string} en - English text
   * @returns {string} The text in the current language, or fallback to the other language if empty
   */
  const getLocalizedText = (ar, en) => {
    // Check current language - 'ae' for Arabic, 'en' for English
    const isArabic = i18n.language === "ae";
    const primaryText = isArabic ? ar : en;
    const fallbackText = isArabic ? en : ar;

    // Return primary text if it exists and is not empty, otherwise return fallback
    return (
      (primaryText && primaryText?.trim() !== ""
        ? primaryText
        : fallbackText) ?? "-"
    );
  };

  const getLocalizedNumber = (number) => {
    if (!number) return false;
    return number
  };

  const getLocalizedDate = (date, format = "DD - MMMM YYYY") => {
    if (!date) return false;
    return i18n.language === "ae"
      ? formatDate(date, "ae", format)
      : formatDate(date, "en", format);
  };

  return { getLocalizedText, getLocalizedNumber, getLocalizedDate };
}
